import { render, staticRenderFns } from "./c_busy.vue?vue&type=template&id=60b9d730&"
import script from "./c_busy.vue?vue&type=script&lang=js&"
export * from "./c_busy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports